import { createApi } from '@reduxjs/toolkit/query/react';
import { GraphQLClient } from 'graphql-request';
import { config } from 'lib-shared-backend-config';

import {
  ArticleQuery,
  ArticleQueryVariables,
  KcsSettingsQuery,
  KcsSettingsQueryVariables,
  ResolutionSearchArticlesQuery,
  ResolutionSearchArticlesQueryVariables,
  SearchArticlesQuery,
  SearchArticlesQueryVariables,
  SuggestionsByTagQuery,
  SuggestionsByTagQueryVariables,
  SuggestionsQuery,
  SuggestionsQueryVariables,
  UserSettingsQuery,
  UserSettingsQueryVariables,
} from 'components/conversation/components/integrations/elevio/src/apis/graphQl/elevio/grappa/types/grappa.types';
import { elevioBaseQuery } from 'components/conversation/components/integrations/elevio/src/utils/apis/graphql/baseQuery';

import { elevioUrls } from '../../../../utils/apis';

import {
  articleQuery,
  kcsSettingsQuery,
  resolutionSearchArticlesQuery,
  searchArticlesQuery,
  suggestionsByTagQuery,
  suggestionsQuery,
  userSettingsQuery,
} from './grappa.queries';

const grappaUrl =
  config.environment === 'prod'
    ? elevioUrls.production.grappa
    : elevioUrls.staging.grappa;

const grappaClient: GraphQLClient = new GraphQLClient(grappaUrl);

/** Grappa is a private Elevio API with read-only operations */
export const grappaApi = createApi({
  baseQuery: elevioBaseQuery(grappaClient),
  endpoints: (builder) => ({
    searchArticles: builder.query<
      SearchArticlesQuery,
      SearchArticlesQueryVariables
    >({
      query: (variables) => ({
        document: searchArticlesQuery,
        variables,
      }),
    }),
    article: builder.query<ArticleQuery, ArticleQueryVariables>({
      query: (variables) => ({
        document: articleQuery,
        variables,
      }),
    }),
    suggestions: builder.query<SuggestionsQuery, SuggestionsQueryVariables>({
      query: (variables) => ({
        document: suggestionsQuery,
        variables,
      }),
    }),
    suggestionsByTags: builder.query<
      SuggestionsByTagQuery,
      SuggestionsByTagQueryVariables
    >({
      query: (variables) => ({
        document: suggestionsByTagQuery,
        variables,
      }),
    }),

    kcsSettings: builder.query<KcsSettingsQuery, KcsSettingsQueryVariables>({
      query: (variables) => ({
        document: kcsSettingsQuery,
        variables,
      }),
    }),

    userSettings: builder.query<UserSettingsQuery, UserSettingsQueryVariables>({
      query: (variables) => ({
        document: userSettingsQuery,
        variables,
      }),
    }),

    resolutionSearchArticles: builder.query<
      ResolutionSearchArticlesQuery,
      ResolutionSearchArticlesQueryVariables
    >({
      query: (variables) => ({
        document: resolutionSearchArticlesQuery,
        variables,
      }),
    }),
  }),
  reducerPath: 'elevioGrappaApi',
});
